import { render, staticRenderFns } from "./ProjectTaskEditFormFrProject.vue?vue&type=template&id=9ac8a8dc"
import script from "./ProjectTaskEditFormFrProject.vue?vue&type=script&lang=js"
export * from "./ProjectTaskEditFormFrProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports